(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('NormaDeleteController',NormaDeleteController);

    NormaDeleteController.$inject = ['$q','$uibModalInstance', 'entity', 'organosResponse','documentosResponse', 'Norma', 'OrganoRelevante','Documento'];

    function NormaDeleteController($q, $uibModalInstance, entity, organosResponse,documentosResponse, Norma, OrganoRelevante,Documento) {
        var vm = this;

        vm.norma = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.promises = [];
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function confirmDelete (id) {
                
            if(organosResponse!=null && organosResponse!=undefined && organosResponse.length>0){
                for (var i = 0; i < organosResponse.length; i++) {
                    vm.promises.push(OrganoRelevante.delete({id : organosResponse[i].id}).$promise);
                };
            }
            if(documentosResponse!=null && documentosResponse!=undefined && documentosResponse.length>0){
                for (var i = 0; i < documentosResponse.length; i++) {
                    vm.promises.push(Documento.delete({id : documentosResponse[i].id}).$promise);
                };
            }
            $q.all(vm.promises).then(function () {
                    Norma.delete({id: id},
                        function () {
                            $uibModalInstance.close(true);
                    });

            }).catch(function() {
                console.error("error at exec all the promises");
            }); 
            
        }

    }
})();
